/**
 * Shared scroll-triggered reveal animation using IntersectionObserver.
 * Call once per page to activate all elements with the `.reveal` class.
 */
export function initScrollReveal(selector, threshold) {
  var reveals = document.querySelectorAll(selector || ".reveal");
  if (!reveals.length || !("IntersectionObserver" in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: threshold || 0.15 }
  );
  reveals.forEach(function (el) {
    observer.observe(el);
  });
}
